import styles from '../reward-details-card.module.scss';

const data = [
  { pkg: 'Premium', stars: '15' },
  { pkg: 'Compact Plus', stars: '12' },
  { pkg: 'Compact', stars: '10' },
  { pkg: 'Family', stars: '7' },
  { pkg: 'Access', stars: '5' },
  { pkg: 'EasyView', stars: '3' },
];

function StarsChart({ packages }: { packages: { name: string; stars: string }[] }) {
  if (!packages?.length) {
    return;
  }

  return (
    <>
      <h4 className="text-small-bold">
        Depending on which package you have you will earn a different amount of stars:
      </h4>
      <div className={styles.chart}>
        {packages.map((pkg, i) => (
          <div className="d-flex justify-content-between text-primary text-label text-label-bold" key={i}>
            <p className="cust-mb-1">{pkg.name}</p>
            <p className="d-flex align-items-center cust-mb-1">
              {pkg.stars} <i className="icon-star_full text-body-small ml-1" />
            </p>
          </div>
        ))}
      </div>
    </>
  );
}

export default StarsChart;